import {Injectable} from '@angular/core';
import {Client, Message} from '@stomp/stompjs';
import * as SockJS from 'sockjs-client';
import {BehaviorSubject, Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {UserService} from './user.service';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private stompClient!: Client;
  private messagesSubject = new BehaviorSubject<any>(null);

  constructor(
    public userService: UserService,
  ) {}

  connect(groupIds: number[]) {
    const socket = new SockJS(environment.websocket);
    const userEmail = this.userService.user.email
    console.log(groupIds);
    console.log(userEmail);
    this.stompClient = new Client({
      webSocketFactory: () => socket,
      reconnectDelay: 60000,
      debug: (msg) => console.log('STOMP Debug:', msg),
      onConnect: () => {
        console.log('WebSocket conectado');

        this.stompClient.publish({
          destination: `/app/connect/${userEmail}`,
        });

        groupIds.forEach(topic => {
          this.stompClient.subscribe(`/topic/${topic.toString()}`, (message: Message) => {
            const receivedMessage = JSON.parse(message.body);
            this.messagesSubject.next(receivedMessage);
          });
        });


        // Chamadas para múltiplos endpoints no momento da conexão
        // const endpoints = [`/app/connect/${userName}`];
        // endpoints.forEach(destination => {
        //   this.stompClient.publish({ destination });
        // });

        // this.stompClient.subscribe(`/topic/${userName}`, (message: Message) => {
        //   const receivedMessage = JSON.parse(message.body);
        //   this.messagesSubject.next(receivedMessage);
        // });


      },
      onStompError: (frame) => {
        console.error('Erro STOMP:', frame);
      }
    });
    this.stompClient.activate();
  }

  sendMessage(userName: string, message: any) {
    this.stompClient.publish({
      destination: `/app/chat/${userName}`,
      body: JSON.stringify(message),
    });
  }

  getMessages(): Observable<any> {
    return this.messagesSubject.asObservable();
  }

  disconnect() {
    if (this.stompClient && this.stompClient.active) {
      this.stompClient.deactivate();
      console.log('WebSocket desconectado');
    }
  }
}
